var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md12: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-container",
                { attrs: { "grid-list-md": "" } },
                [
                  _c(
                    "v-form",
                    { staticClass: "col-md-12" },
                    [
                      _c("StepTitle", [
                        _vm._v("Asociar Flotas, Etiquetas o Vehículos")
                      ]),
                      _c("v-divider"),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md12: "", lg12: "" } },
                            [
                              _c(
                                "v-radio-group",
                                {
                                  attrs: { row: "" },
                                  model: {
                                    value: _vm.tipoAsociacion,
                                    callback: function($$v) {
                                      _vm.tipoAsociacion = $$v
                                    },
                                    expression: "tipoAsociacion"
                                  }
                                },
                                [
                                  _c("v-radio", {
                                    attrs: {
                                      label: "Flotas",
                                      value: _vm.tiposAsociacion.flota
                                    }
                                  }),
                                  _c("v-radio", {
                                    attrs: {
                                      label: "Etiquetas",
                                      value: _vm.tiposAsociacion.etiqueta
                                    }
                                  }),
                                  _c("v-radio", {
                                    attrs: {
                                      label: "Vehículos",
                                      value: _vm.tiposAsociacion.vehiculo
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { attrs: { align: "left" } },
                        [
                          _c("AsociarFlotas", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.tipoAsociacion ===
                                  _vm.tiposAsociacion.flota,
                                expression:
                                  "tipoAsociacion === tiposAsociacion.flota"
                              }
                            ],
                            attrs: {
                              "test-id": "AsociarFlotaEtiquetaVehiculo",
                              flotas: _vm.flotas.todos,
                              "flotas-seleccionadas": _vm.flotas.seleccionados,
                              readonly: _vm.readonly,
                              esEditar: _vm.esEditar,
                              show:
                                _vm.tipoAsociacion === _vm.tiposAsociacion.flota
                            },
                            on: {
                              selectionChange: _vm.handleSelectedFlotasChange
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { attrs: { align: "left" } },
                        [
                          _c("AsociarEtiquetas", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.tipoAsociacion ===
                                  _vm.tiposAsociacion.etiqueta,
                                expression:
                                  "tipoAsociacion === tiposAsociacion.etiqueta"
                              }
                            ],
                            attrs: {
                              "test-id": "AsociarFlotaEtiquetaVehiculo",
                              etiquetas: _vm.etiquetas.todos,
                              "etiquetas-seleccionadas":
                                _vm.etiquetas.seleccionados,
                              readonly: _vm.readonly,
                              esEditar: _vm.esEditar,
                              show:
                                _vm.tipoAsociacion ===
                                _vm.tiposAsociacion.etiqueta
                            },
                            on: {
                              selectionChange:
                                _vm.handleSelectedEtiquetasUserChange
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { attrs: { align: "left" } },
                        [
                          _c("AsociarVehiculos", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.tipoAsociacion ===
                                  _vm.tiposAsociacion.vehiculo,
                                expression:
                                  "tipoAsociacion === tiposAsociacion.vehiculo"
                              }
                            ],
                            attrs: {
                              "test-id": "AsociarFlotaEtiquetaVehiculo",
                              vehiculos: _vm.vehiculos.todos,
                              "vehiculos-seleccionados":
                                _vm.vehiculos.seleccionados,
                              readonly: _vm.readonly,
                              esEditar: _vm.esEditar,
                              columnDefs: _vm.colDefVehiculo,
                              show:
                                _vm.tipoAsociacion ===
                                _vm.tiposAsociacion.vehiculo
                            },
                            on: {
                              selectionChange: _vm.handleSelectedVehiculosChange
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }